"use strict";

import * as bootstrap from 'bootstrap';
import { gsap } from 'gsap';
import { CSSPlugin } from 'gsap/CSSPlugin';
import ShareButtons from 'share-buttons';

window.bootstrap = bootstrap; // ora puoi usare window.bootstrap.Tooltip ecc.
window.gsap = gsap;
window.ShareButtons = ShareButtons;
gsap.registerPlugin(CSSPlugin);

export { bootstrap, gsap, ShareButtons };
